<template>
  <a
    :class="[
      'sai-link',
      disable ? `disable text-${disableColor}` : `text-${color}`,
      {
        'sai-link--underlined': underlined
      }
    ]"
    v-on="$listeners"
    :href="href"
    :target="target"
  >
    <slot>{{ label || href }}</slot>
  </a>
</template>

<script>
export default {
  name: 'SAILink',
  props: {
    label: {
      type: String
    },
    href: {
      type: String
    },
    target: {
      type: String
    },
    color: {
      type: String,
      default: 'primary'
    },
    disableColor: {
      type: String,
      default: 'grey-6'
    },
    disable: {
      type: Boolean
    },
    underlined: {
      type: Boolean
    }
  }
};
</script>

<style lang="sass" scoped>
.sai-link
  &:not(.sai-link--underlined)
    text-decoration: none

  &:hover:not(.disable)
      text-decoration: underline

  &.disable
    pointer-events: none
    text-decoration: none
</style>
